import { __decorate, __metadata } from "tslib";
import { IsUndefinable, IsUUIDWithLVS, LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsString, ValidateIf } from 'class-validator';
import { DiningOptionPropertyTypeEnum } from '../enum';
import { DiningOptionExposeGroup } from '../interface';
export class PatchDiningOptionPropertyDto {
    constructor() {
        this.isRequired = false;
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Dinning option uuid', example: 'e55acc6f-2f34-442c-92d3-d4188fb88845' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [DiningOptionExposeGroup.PATCH] }),
    IsUUIDWithLVS(4, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "diningOptionUuid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Dinning option property group uuid', example: 'flip87w09' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ always: true }),
    IsUUIDWithLVS(4, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "diningOptionPropertyGroupUuid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Is required dinning option property group', default: false }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchDiningOptionPropertyDto.prototype, "isRequired", void 0);
__decorate([
    ApiPropertyOptional({ enum: DiningOptionPropertyTypeEnum, description: 'Dinning option property type', example: DiningOptionPropertyTypeEnum.INT8 }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsEnum(DiningOptionPropertyTypeEnum, { always: true }),
    ValidateIf((object) => object.type !== undefined || object.enum !== undefined, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, description: 'Dinning option property enum', example: ['BMW'] }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    ValidateIf((object) => object.enum !== undefined || object.type !== undefined, { each: true, always: true }),
    __metadata("design:type", Array)
], PatchDiningOptionPropertyDto.prototype, "enum", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Dinning option property label', example: 'Car Model' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [DiningOptionExposeGroup.PATCH] }),
    IsString({ always: true }),
    LengthWithLVS(1, 250, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "label", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Dinning option property placeholder', example: 'Ex. Toyota' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 250, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "placeholder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Dinning option property pattern', example: '^(\\([0-9]{3}\\))?[0-9]{3}-[0-9]{4}$' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 250, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "pattern", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Dinning option property component', example: 'TEXTAREA' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 250, { always: true }),
    __metadata("design:type", String)
], PatchDiningOptionPropertyDto.prototype, "component", void 0);
//# sourceMappingURL=PatchDiningOptionPropertyDto.js.map